import script from "./RaceSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./RaceSelection.vue?vue&type=script&setup=true&lang=js"

import "./RaceSelection.vue?vue&type=style&index=0&id=df9cc4e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df9cc4e8"]])

export default __exports__